module.exports = __webpack_public_path__ + "img/eva_video-fill.1cf4e94a.svg";